/**
 * Worker R2 Endpoints — fuente única de verdad
 *
 * Centraliza el dominio del Worker R2 (`geodata.pteltool.es`) y sus rutas
 * frecuentes. Cierra la centralización planificada en `r2Config.ts:21` pero
 * nunca completada: sustituye los 33 archivos productivos que hardcodean el
 * dominio antiguo `ptel-geodata.luis-mu-oz.workers.dev`.
 *
 * Auditoría empírica: `.ptel/STRATEGY_URL_FALLBACK_20260504.md` §13 (K3PM).
 * Migración: `DRIFT-H4XR-2` (sesión K3PM-bis 2026-05-04).
 *
 * @module lib/config/workerEndpoints
 */

/**
 * Dominio base del Worker R2 (custom domain, producción).
 *
 * Anteriormente: `https://ptel-geodata.luis-mu-oz.workers.dev`
 * (workers.dev legacy, conservado en handlers MSW como fallback de matcher).
 */
export const WORKER_BASE = 'https://geodata.pteltool.es';

/**
 * Dominio base + prefijo `/v1` para rutas versionadas
 * (CDAU, NGA, DERA, AGOL, Catastro y demás capas R2).
 */
export const WORKER_BASE_V1 = `${WORKER_BASE}/v1`;

/**
 * Helpers de paths concretos frecuentes.
 */
export const WORKER_HEALTH = `${WORKER_BASE}/health`;

/**
 * Base del Worker para el historial de ediciones (`/coord-edits`).
 *
 * SEC0-c1 (DOP-1 a): ya no lee `VITE_WORKER_URL`. Esa variable valía
 * `ptel-geodata.luis-mu-oz.workers.dev` en Pages y en el CI (apagado, 404),
 * así que el historial nunca llegaba al Worker. Se conserva el nombre para no
 * tocar a sus dos lectores (`EditHistoryPanel`, `HistorialSection`).
 */
export const WORKER_BASE_RUNTIME = WORKER_BASE;

export const WORKER_BASE_V1_RUNTIME = `${WORKER_BASE_RUNTIME}/v1`;
